import { useAnswersForRespondentType } from '../../context/render-context';

const getAnswerLabel = (
  isNotCompleted: boolean,
  isNotShown: boolean,
  isSkipped?: boolean
): 'report.questionNotCompleted' | 'report.questionNotShown' | 'report.answerSkipped' | null => {
  if (isNotCompleted) return 'report.questionNotCompleted';
  if (isNotShown) return 'report.questionNotShown';
  if (isSkipped) return 'report.answerSkipped';
  return null;
};

const shouldShowNotCompleted = (
  multipleRespondents: boolean,
  answers: ReturnType<typeof useAnswersForRespondentType>
): boolean => {
  if (!multipleRespondents) return false;
  return answers === undefined || Object.keys(answers).length === 0;
};

export { getAnswerLabel, shouldShowNotCompleted };
